import { render, staticRenderFns } from "./ApplicationsTabList.vue?vue&type=template&id=17836ff2&scoped=true"
import script from "./ApplicationsTabList.vue?vue&type=script&lang=js"
export * from "./ApplicationsTabList.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsTabList.vue?vue&type=style&index=0&id=17836ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17836ff2",
  null
  
)

export default component.exports